@file:OptIn(InternalResourceApi::class)

package one.devsbox.www.www_portal.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/one.devsbox.www.www_portal.generated.resources/"

@delegate:ResourceContentHash(-106_461_003)
internal val Res.string.ui_resources_detail_unknown: StringResource by lazy {
      StringResource("string:ui_resources_detail_unknown", "ui_resources_detail_unknown", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 20909, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19945, 47),
      ))
    }

@delegate:ResourceContentHash(1_491_743_000)
internal val Res.string.ui_resources_listing_btn_upload: StringResource by lazy {
      StringResource("string:ui_resources_listing_btn_upload", "ui_resources_listing_btn_upload", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 20957, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19993, 47),
      ))
    }

@delegate:ResourceContentHash(82_608_977)
internal val Res.string.ui_resources_listing_filter_opt_all: StringResource by lazy {
      StringResource("string:ui_resources_listing_filter_opt_all", "ui_resources_listing_filter_opt_all", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 21009, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20041, 47),
      ))
    }

@delegate:ResourceContentHash(-1_064_683_175)
internal val Res.string.ui_resources_listing_filter_opt_horizontal: StringResource by lazy {
      StringResource("string:ui_resources_listing_filter_opt_horizontal", "ui_resources_listing_filter_opt_horizontal", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 21057, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20089, 66),
      ))
    }

@delegate:ResourceContentHash(384_645_533)
internal val Res.string.ui_resources_listing_filter_opt_image: StringResource by lazy {
      StringResource("string:ui_resources_listing_filter_opt_image", "ui_resources_listing_filter_opt_image", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 21124, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20156, 53),
      ))
    }

@delegate:ResourceContentHash(-1_928_995_252)
internal val Res.string.ui_resources_listing_filter_opt_vertical: StringResource by lazy {
      StringResource("string:ui_resources_listing_filter_opt_vertical", "ui_resources_listing_filter_opt_vertical", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 21178, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20210, 60),
      ))
    }

@delegate:ResourceContentHash(1_085_756_160)
internal val Res.string.ui_resources_listing_filter_opt_video: StringResource by lazy {
      StringResource("string:ui_resources_listing_filter_opt_video", "ui_resources_listing_filter_opt_video", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 21243, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20271, 53),
      ))
    }

@delegate:ResourceContentHash(-1_990_354_322)
internal val Res.string.ui_resources_listing_filter_orientation: StringResource by lazy {
      StringResource("string:ui_resources_listing_filter_orientation", "ui_resources_listing_filter_orientation", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 21297, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20325, 63),
      ))
    }

@delegate:ResourceContentHash(394_632_241)
internal val Res.string.ui_resources_listing_filter_type: StringResource by lazy {
      StringResource("string:ui_resources_listing_filter_type", "ui_resources_listing_filter_type", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 21361, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20389, 48),
      ))
    }

@delegate:ResourceContentHash(-673_813_401)
internal val Res.string.ui_resources_listing_no_resources_found: StringResource by lazy {
      StringResource("string:ui_resources_listing_no_resources_found", "ui_resources_listing_no_resources_found", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 21410, 131),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20438, 111),
      ))
    }

@delegate:ResourceContentHash(-61_401_431)
internal val Res.string.ui_resources_listing_search_pick_placeholder: StringResource by lazy {
      StringResource("string:ui_resources_listing_search_pick_placeholder", "ui_resources_listing_search_pick_placeholder", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 21542, 92),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20550, 84),
      ))
    }

@delegate:ResourceContentHash(-1_847_630_584)
internal val Res.string.ui_resources_listing_search_placeholder: StringResource by lazy {
      StringResource("string:ui_resources_listing_search_placeholder", "ui_resources_listing_search_placeholder", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 21635, 75),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20635, 59),
      ))
    }

@delegate:ResourceContentHash(-2_015_501_098)
internal val Res.string.ui_resources_listing_showing: StringResource by lazy {
      StringResource("string:ui_resources_listing_showing", "ui_resources_listing_showing", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 21711, 88),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20695, 84),
      ))
    }

@delegate:ResourceContentHash(-235_470_579)
internal val Res.string.ui_resources_splash_desc: StringResource by lazy {
      StringResource("string:ui_resources_splash_desc", "ui_resources_splash_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 21800, 244),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20780, 208),
      ))
    }

@delegate:ResourceContentHash(-844_214_366)
internal val Res.string.ui_resources_splash_title: StringResource by lazy {
      StringResource("string:ui_resources_splash_title", "ui_resources_splash_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 22045, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20989, 49),
      ))
    }

@delegate:ResourceContentHash(-1_238_941_292)
internal val Res.string.ui_target_campaign: StringResource by lazy {
      StringResource("string:ui_target_campaign", "ui_target_campaign", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 22143, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21079, 38),
      ))
    }

@delegate:ResourceContentHash(-1_238_925_862)
internal val Res.string.ui_target_campaigns: StringResource by lazy {
      StringResource("string:ui_target_campaigns", "ui_target_campaigns", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 22103, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21039, 39),
      ))
    }

@delegate:ResourceContentHash(-1_995_450_493)
internal val Res.string.ui_target_companies: StringResource by lazy {
      StringResource("string:ui_target_companies", "ui_target_companies", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 22182, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21118, 39),
      ))
    }

@delegate:ResourceContentHash(-1_995_335_475)
internal val Res.string.ui_target_company: StringResource by lazy {
      StringResource("string:ui_target_company", "ui_target_company", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 22218, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21158, 37),
      ))
    }

@delegate:ResourceContentHash(1_269_429_100)
internal val Res.string.ui_target_device: StringResource by lazy {
      StringResource("string:ui_target_device", "ui_target_device", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 22290, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21234, 32),
      ))
    }

@delegate:ResourceContentHash(-2_800_520)
internal val Res.string.ui_target_devices: StringResource by lazy {
      StringResource("string:ui_target_devices", "ui_target_devices", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 22252, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21196, 37),
      ))
    }

@delegate:ResourceContentHash(-1_385_667_318)
internal val Res.string.ui_target_location: StringResource by lazy {
      StringResource("string:ui_target_location", "ui_target_location", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 22367, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21307, 38),
      ))
    }

@delegate:ResourceContentHash(-1_385_651_888)
internal val Res.string.ui_target_locations: StringResource by lazy {
      StringResource("string:ui_target_locations", "ui_target_locations", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 22327, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21267, 39),
      ))
    }

@delegate:ResourceContentHash(1_300_809_559)
internal val Res.string.ui_target_resource: StringResource by lazy {
      StringResource("string:ui_target_resource", "ui_target_resource", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 22446, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21386, 38),
      ))
    }

@delegate:ResourceContentHash(1_997_239_247)
internal val Res.string.ui_target_resources: StringResource by lazy {
      StringResource("string:ui_target_resources", "ui_target_resources", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 22406, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21346, 39),
      ))
    }

@delegate:ResourceContentHash(-165_470_589)
internal val Res.string.ui_target_user: StringResource by lazy {
      StringResource("string:ui_target_user", "ui_target_user", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 22517, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21457, 30),
      ))
    }

@delegate:ResourceContentHash(-165_500_442)
internal val Res.string.ui_target_users: StringResource by lazy {
      StringResource("string:ui_target_users", "ui_target_users", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 22481, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21425, 31),
      ))
    }

@delegate:ResourceContentHash(-723_488_708)
internal val Res.string.ui_uploader_btn_image: StringResource by lazy {
      StringResource("string:ui_uploader_btn_image", "ui_uploader_btn_image", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 22552, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21488, 45),
      ))
    }

@delegate:ResourceContentHash(851_642_094)
internal val Res.string.ui_uploader_btn_try_again: StringResource by lazy {
      StringResource("string:ui_uploader_btn_try_again", "ui_uploader_btn_try_again", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 22602, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21534, 45),
      ))
    }

@delegate:ResourceContentHash(1_205_336_578)
internal val Res.string.ui_uploader_btn_video: StringResource by lazy {
      StringResource("string:ui_uploader_btn_video", "ui_uploader_btn_video", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 22660, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21580, 45),
      ))
    }

@delegate:ResourceContentHash(-136_658_165)
internal val Res.string.ui_uploader_desc_image: StringResource by lazy {
      StringResource("string:ui_uploader_desc_image", "ui_uploader_desc_image", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 22710, 102),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21626, 98),
      ))
    }

@delegate:ResourceContentHash(353_421_141)
internal val Res.string.ui_uploader_desc_video: StringResource by lazy {
      StringResource("string:ui_uploader_desc_video", "ui_uploader_desc_video", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 22813, 98),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21725, 94),
      ))
    }

@delegate:ResourceContentHash(-613_029_644)
internal val Res.string.ui_uploader_error_prefix: StringResource by lazy {
      StringResource("string:ui_uploader_error_prefix", "ui_uploader_error_prefix", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 22912, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21820, 60),
      ))
    }

@delegate:ResourceContentHash(-416_868_614)
internal val Res.string.ui_uploader_fail_title: StringResource by lazy {
      StringResource("string:ui_uploader_fail_title", "ui_uploader_fail_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 22985, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21881, 58),
      ))
    }

@delegate:ResourceContentHash(-1_807_433_538)
internal val Res.string.ui_uploader_status_back: StringResource by lazy {
      StringResource("string:ui_uploader_status_back", "ui_uploader_status_back", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 23040, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21940, 39),
      ))
    }

@delegate:ResourceContentHash(1_341_409_348)
internal val Res.string.ui_uploader_status_init: StringResource by lazy {
      StringResource("string:ui_uploader_status_init", "ui_uploader_status_init", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 23080, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21980, 63),
      ))
    }

@delegate:ResourceContentHash(475_135_225)
internal val Res.string.ui_uploader_status_processing: StringResource by lazy {
      StringResource("string:ui_uploader_status_processing", "ui_uploader_status_processing", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 23144, 97),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22044, 85),
      ))
    }

@delegate:ResourceContentHash(2_077_531_598)
internal val Res.string.ui_uploader_status_secure_legend: StringResource by lazy {
      StringResource("string:ui_uploader_status_secure_legend", "ui_uploader_status_secure_legend", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 23242, 148),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22130, 140),
      ))
    }

@delegate:ResourceContentHash(1_871_400_985)
internal val Res.string.ui_uploader_status_secure_transfer: StringResource by lazy {
      StringResource("string:ui_uploader_status_secure_transfer", "ui_uploader_status_secure_transfer", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 23391, 78),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22271, 70),
      ))
    }

@delegate:ResourceContentHash(-588_750_528)
internal val Res.string.ui_uploader_status_uploading: StringResource by lazy {
      StringResource("string:ui_uploader_status_uploading", "ui_uploader_status_uploading", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 23470, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22342, 60),
      ))
    }

@delegate:ResourceContentHash(664_920_738)
internal val Res.string.ui_uploader_subtitle: StringResource by lazy {
      StringResource("string:ui_uploader_subtitle", "ui_uploader_subtitle", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 23535, 80),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22403, 76),
      ))
    }

@delegate:ResourceContentHash(-792_987_503)
internal val Res.string.ui_uploader_title: StringResource by lazy {
      StringResource("string:ui_uploader_title", "ui_uploader_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 23616, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22480, 45),
      ))
    }

@delegate:ResourceContentHash(890_491_875)
internal val Res.string.ui_users_activity_btn_next: StringResource by lazy {
      StringResource("string:ui_users_activity_btn_next", "ui_users_activity_btn_next", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 23682, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22526, 42),
      ))
    }

@delegate:ResourceContentHash(651_404_420)
internal val Res.string.ui_users_activity_btn_prev: StringResource by lazy {
      StringResource("string:ui_users_activity_btn_prev", "ui_users_activity_btn_prev", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 23729, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22569, 46),
      ))
    }

@delegate:ResourceContentHash(301_918_664)
internal val Res.string.ui_users_activity_empty: StringResource by lazy {
      StringResource("string:ui_users_activity_empty", "ui_users_activity_empty", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 23776, 79),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22616, 67),
      ))
    }

@delegate:ResourceContentHash(-822_165_339)
internal val Res.string.ui_users_activity_filter_action: StringResource by lazy {
      StringResource("string:ui_users_activity_filter_action", "ui_users_activity_filter_action", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 23856, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22684, 51),
      ))
    }

@delegate:ResourceContentHash(82_546_257)
internal val Res.string.ui_users_activity_filter_all: StringResource by lazy {
      StringResource("string:ui_users_activity_filter_all", "ui_users_activity_filter_all", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 23908, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22736, 40),
      ))
    }

@delegate:ResourceContentHash(-1_684_057_908)
internal val Res.string.ui_users_activity_filter_target: StringResource by lazy {
      StringResource("string:ui_users_activity_filter_target", "ui_users_activity_filter_target", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 23949, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22777, 51),
      ))
    }

@delegate:ResourceContentHash(-1_879_381_979)
internal val Res.string.ui_users_activity_header_action: StringResource by lazy {
      StringResource("string:ui_users_activity_header_action", "ui_users_activity_header_action", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 23997, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22829, 47),
      ))
    }

@delegate:ResourceContentHash(1_634_444_242)
internal val Res.string.ui_users_activity_header_details: StringResource by lazy {
      StringResource("string:ui_users_activity_header_details", "ui_users_activity_header_details", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 24045, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22877, 52),
      ))
    }

@delegate:ResourceContentHash(699_379_114)
internal val Res.string.ui_users_activity_header_timestamp: StringResource by lazy {
      StringResource("string:ui_users_activity_header_timestamp", "ui_users_activity_header_timestamp", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 24098, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22930, 54),
      ))
    }

@delegate:ResourceContentHash(-165_470_589)
internal val Res.string.ui_users_activity_header_user: StringResource by lazy {
      StringResource("string:ui_users_activity_header_user", "ui_users_activity_header_user", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 24165, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22985, 45),
      ))
    }

@delegate:ResourceContentHash(2_056_327_806)
internal val Res.string.ui_users_activity_hours_ago: StringResource by lazy {
      StringResource("string:ui_users_activity_hours_ago", "ui_users_activity_hours_ago", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 24215, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23031, 55),
      ))
    }

@delegate:ResourceContentHash(-2_112_190_972)
internal val Res.string.ui_users_activity_mins_ago: StringResource by lazy {
      StringResource("string:ui_users_activity_mins_ago", "ui_users_activity_mins_ago", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 24271, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23087, 54),
      ))
    }

@delegate:ResourceContentHash(-1_503_210_980)
internal val Res.string.ui_users_activity_now: StringResource by lazy {
      StringResource("string:ui_users_activity_now", "ui_users_activity_now", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 24326, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23142, 33),
      ))
    }

@delegate:ResourceContentHash(-1_281_005_611)
internal val Res.string.ui_users_activity_title: StringResource by lazy {
      StringResource("string:ui_users_activity_title", "ui_users_activity_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 24364, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23176, 47),
      ))
    }

@delegate:ResourceContentHash(-1_193_551_646)
internal val Res.string.ui_users_detail_btn_audit_trail: StringResource by lazy {
      StringResource("string:ui_users_detail_btn_audit_trail", "ui_users_detail_btn_audit_trail", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 24420, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23224, 59),
      ))
    }

@delegate:ResourceContentHash(-24_625_281)
internal val Res.string.ui_users_detail_btn_delete: StringResource by lazy {
      StringResource("string:ui_users_detail_btn_delete", "ui_users_detail_btn_delete", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 24492, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23284, 42),
      ))
    }

@delegate:ResourceContentHash(-503_216_827)
internal val Res.string.ui_users_detail_btn_edit: StringResource by lazy {
      StringResource("string:ui_users_detail_btn_edit", "ui_users_detail_btn_edit", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 24539, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23327, 40),
      ))
    }

@delegate:ResourceContentHash(-1_588_786_152)
internal val Res.string.ui_users_detail_btn_reset_pass: StringResource by lazy {
      StringResource("string:ui_users_detail_btn_reset_pass", "ui_users_detail_btn_reset_pass", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 24580, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23368, 54),
      ))
    }

@delegate:ResourceContentHash(-1_238_925_862)
internal val Res.string.ui_users_detail_cat_campaigns: StringResource by lazy {
      StringResource("string:ui_users_detail_cat_campaigns", "ui_users_detail_cat_campaigns", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 24651, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23423, 49),
      ))
    }

@delegate:ResourceContentHash(-1_995_450_493)
internal val Res.string.ui_users_detail_cat_company: StringResource by lazy {
      StringResource("string:ui_users_detail_cat_company", "ui_users_detail_cat_company", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 24701, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23473, 47),
      ))
    }

@delegate:ResourceContentHash(-2_800_520)
internal val Res.string.ui_users_detail_cat_devices: StringResource by lazy {
      StringResource("string:ui_users_detail_cat_devices", "ui_users_detail_cat_devices", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 24745, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23521, 47),
      ))
    }

@delegate:ResourceContentHash(-1_385_651_888)
internal val Res.string.ui_users_detail_cat_locations: StringResource by lazy {
      StringResource("string:ui_users_detail_cat_locations", "ui_users_detail_cat_locations", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 24793, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23569, 49),
      ))
    }

@delegate:ResourceContentHash(-1_592_717_250)
internal val Res.string.ui_users_detail_cat_media: StringResource by lazy {
      StringResource("string:ui_users_detail_cat_media", "ui_users_detail_cat_media", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 24843, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23619, 41),
      ))
    }

@delegate:ResourceContentHash(-165_500_442)
internal val Res.string.ui_users_detail_cat_users: StringResource by lazy {
      StringResource("string:ui_users_detail_cat_users", "ui_users_detail_cat_users", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 24885, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23661, 41),
      ))
    }

@delegate:ResourceContentHash(-24_625_281)
internal val Res.string.ui_users_detail_delete_btn_confirm: StringResource by lazy {
      StringResource("string:ui_users_detail_delete_btn_confirm", "ui_users_detail_delete_btn_confirm", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 24931, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23703, 50),
      ))
    }

@delegate:ResourceContentHash(1_573_769_046)
internal val Res.string.ui_users_detail_delete_btn_dismiss: StringResource by lazy {
      StringResource("string:ui_users_detail_delete_btn_dismiss", "ui_users_detail_delete_btn_dismiss", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 24986, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23754, 54),
      ))
    }

@delegate:ResourceContentHash(900_198_363)
internal val Res.string.ui_users_detail_delete_confirm_message: StringResource by lazy {
      StringResource("string:ui_users_detail_delete_confirm_message", "ui_users_detail_delete_confirm_message", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 25041, 162),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23809, 142),
      ))
    }

@delegate:ResourceContentHash(-703_793_327)
internal val Res.string.ui_users_detail_delete_confirm_title: StringResource by lazy {
      StringResource("string:ui_users_detail_delete_confirm_title", "ui_users_detail_delete_confirm_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 25204, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23952, 60),
      ))
    }

@delegate:ResourceContentHash(-645_535_466)
internal val Res.string.ui_users_detail_header_category: StringResource by lazy {
      StringResource("string:ui_users_detail_header_category", "ui_users_detail_header_category", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 25273, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24013, 51),
      ))
    }

@delegate:ResourceContentHash(-24_625_281)
internal val Res.string.ui_users_detail_header_delete: StringResource by lazy {
      StringResource("string:ui_users_detail_header_delete", "ui_users_detail_header_delete", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 25329, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24065, 45),
      ))
    }

@delegate:ResourceContentHash(-503_216_827)
internal val Res.string.ui_users_detail_header_edit: StringResource by lazy {
      StringResource("string:ui_users_detail_header_edit", "ui_users_detail_header_edit", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 25379, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24111, 43),
      ))
    }

@delegate:ResourceContentHash(546_863_784)
internal val Res.string.ui_users_detail_header_view: StringResource by lazy {
      StringResource("string:ui_users_detail_header_view", "ui_users_detail_header_view", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 25423, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24155, 43),
      ))
    }

@delegate:ResourceContentHash(1_046_818_917)
internal val Res.string.ui_users_detail_info_dialog_title: StringResource by lazy {
      StringResource("string:ui_users_detail_info_dialog_title", "ui_users_detail_info_dialog_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 25471, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24199, 65),
      ))
    }

@delegate:ResourceContentHash(-1_741_625_252)
internal val Res.string.ui_users_detail_log_api_key: StringResource by lazy {
      StringResource("string:ui_users_detail_log_api_key", "ui_users_detail_log_api_key", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 25629, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24349, 63),
      ))
    }

@delegate:ResourceContentHash(1_732_838_760)
internal val Res.string.ui_users_detail_log_api_key_sub: StringResource by lazy {
      StringResource("string:ui_users_detail_log_api_key_sub", "ui_users_detail_log_api_key_sub", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 25545, 83),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24265, 83),
      ))
    }

@delegate:ResourceContentHash(-1_351_564_566)
internal val Res.string.ui_users_detail_log_media: StringResource by lazy {
      StringResource("string:ui_users_detail_log_media", "ui_users_detail_log_media", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 25775, 85),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24487, 73),
      ))
    }

@delegate:ResourceContentHash(1_987_753_433)
internal val Res.string.ui_users_detail_log_media_sub: StringResource by lazy {
      StringResource("string:ui_users_detail_log_media_sub", "ui_users_detail_log_media_sub", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 25697, 77),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24413, 73),
      ))
    }

@delegate:ResourceContentHash(-992_941_020)
internal val Res.string.ui_users_detail_log_sync: StringResource by lazy {
      StringResource("string:ui_users_detail_log_sync", "ui_users_detail_log_sync", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 25938, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24634, 56),
      ))
    }

@delegate:ResourceContentHash(-9_072_540)
internal val Res.string.ui_users_detail_log_sync_sub: StringResource by lazy {
      StringResource("string:ui_users_detail_log_sync_sub", "ui_users_detail_log_sync_sub", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 25861, 76),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24561, 72),
      ))
    }

@delegate:ResourceContentHash(228_077_907)
internal val Res.string.ui_users_detail_reset_success_msg: StringResource by lazy {
      StringResource("string:ui_users_detail_reset_success_msg", "ui_users_detail_reset_success_msg", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 26011, 121),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24691, 97),
      ))
    }

@delegate:ResourceContentHash(-914_010_611)
internal val Res.string.ui_users_detail_title_permissions_matrix: StringResource by lazy {
      StringResource("string:ui_users_detail_title_permissions_matrix", "ui_users_detail_title_permissions_matrix", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 26133, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24789, 72),
      ))
    }

@delegate:ResourceContentHash(1_665_914_557)
internal val Res.string.ui_users_detail_title_recent_logs: StringResource by lazy {
      StringResource("string:ui_users_detail_title_recent_logs", "ui_users_detail_title_recent_logs", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 26202, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24862, 65),
      ))
    }

@delegate:ResourceContentHash(-1_295_076_463)
internal val Res.string.ui_users_edit_btn_ok: StringResource by lazy {
      StringResource("string:ui_users_edit_btn_ok", "ui_users_edit_btn_ok", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 26276, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24928, 32),
      ))
    }

@delegate:ResourceContentHash(936_220_866)
internal val Res.string.ui_users_edit_btn_save: StringResource by lazy {
      StringResource("string:ui_users_edit_btn_save", "ui_users_edit_btn_save", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 26313, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24961, 38),
      ))
    }

@delegate:ResourceContentHash(-1_428_792_705)
internal val Res.string.ui_users_edit_error_title: StringResource by lazy {
      StringResource("string:ui_users_edit_error_title", "ui_users_edit_error_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 26352, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25000, 41),
      ))
    }

@delegate:ResourceContentHash(-305_811_738)
internal val Res.string.ui_users_edit_label_full_name: StringResource by lazy {
      StringResource("string:ui_users_edit_label_full_name", "ui_users_edit_label_full_name", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 26398, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25042, 49),
      ))
    }

@delegate:ResourceContentHash(1_071_582_152)
internal val Res.string.ui_users_edit_label_login_id: StringResource by lazy {
      StringResource("string:ui_users_edit_label_login_id", "ui_users_edit_label_login_id", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 26448, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25092, 48),
      ))
    }

@delegate:ResourceContentHash(-1_519_802_064)
internal val Res.string.ui_users_edit_role_admin: StringResource by lazy {
      StringResource("string:ui_users_edit_role_admin", "ui_users_edit_role_admin", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 26501, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25141, 40),
      ))
    }

@delegate:ResourceContentHash(1_943_914_095)
internal val Res.string.ui_users_edit_role_campaign_publisher: StringResource by lazy {
      StringResource("string:ui_users_edit_role_campaign_publisher", "ui_users_edit_role_campaign_publisher", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 26554, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25182, 69),
      ))
    }

@delegate:ResourceContentHash(-1_973_238_195)
internal val Res.string.ui_users_edit_role_campaign_viewer: StringResource by lazy {
      StringResource("string:ui_users_edit_role_campaign_viewer", "ui_users_edit_role_campaign_viewer", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 26624, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25252, 62),
      ))
    }

@delegate:ResourceContentHash(633_395_640)
internal val Res.string.ui_users_edit_role_technic: StringResource by lazy {
      StringResource("string:ui_users_edit_role_technic", "ui_users_edit_role_technic", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 26695, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25315, 46),
      ))
    }

@delegate:ResourceContentHash(700_475_742)
internal val Res.string.ui_users_edit_role_warning_message: StringResource by lazy {
      StringResource("string:ui_users_edit_role_warning_message", "ui_users_edit_role_warning_message", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 26742, 190),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25362, 182),
      ))
    }

@delegate:ResourceContentHash(1_660_541_432)
internal val Res.string.ui_users_edit_role_warning_title: StringResource by lazy {
      StringResource("string:ui_users_edit_role_warning_title", "ui_users_edit_role_warning_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 26933, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25545, 72),
      ))
    }

@delegate:ResourceContentHash(-1_887_389_032)
internal val Res.string.ui_users_edit_section_roles: StringResource by lazy {
      StringResource("string:ui_users_edit_section_roles", "ui_users_edit_section_roles", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 26998, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25618, 51),
      ))
    }

@delegate:ResourceContentHash(878_832_032)
internal val Res.string.ui_users_edit_title_user_profile: StringResource by lazy {
      StringResource("string:ui_users_edit_title_user_profile", "ui_users_edit_title_user_profile", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 27058, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25670, 56),
      ))
    }

@delegate:ResourceContentHash(71_543_332)
internal val Res.string.ui_users_listing_btn_add_user: StringResource by lazy {
      StringResource("string:ui_users_listing_btn_add_user", "ui_users_listing_btn_add_user", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 27123, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25727, 49),
      ))
    }

@delegate:ResourceContentHash(959_713_004)
internal val Res.string.ui_users_listing_btn_load_more: StringResource by lazy {
      StringResource("string:ui_users_listing_btn_load_more", "ui_users_listing_btn_load_more", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 27181, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25777, 50),
      ))
    }

@delegate:ResourceContentHash(-1_091_319_993)
internal val Res.string.ui_users_listing_header_activity: StringResource by lazy {
      StringResource("string:ui_users_listing_header_activity", "ui_users_listing_header_activity", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 27240, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25828, 60),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString3Resources(map: MutableMap<String, StringResource>) {
  map.put("ui_resources_detail_unknown", Res.string.ui_resources_detail_unknown)
  map.put("ui_resources_listing_btn_upload", Res.string.ui_resources_listing_btn_upload)
  map.put("ui_resources_listing_filter_opt_all", Res.string.ui_resources_listing_filter_opt_all)
  map.put("ui_resources_listing_filter_opt_horizontal", Res.string.ui_resources_listing_filter_opt_horizontal)
  map.put("ui_resources_listing_filter_opt_image", Res.string.ui_resources_listing_filter_opt_image)
  map.put("ui_resources_listing_filter_opt_vertical", Res.string.ui_resources_listing_filter_opt_vertical)
  map.put("ui_resources_listing_filter_opt_video", Res.string.ui_resources_listing_filter_opt_video)
  map.put("ui_resources_listing_filter_orientation", Res.string.ui_resources_listing_filter_orientation)
  map.put("ui_resources_listing_filter_type", Res.string.ui_resources_listing_filter_type)
  map.put("ui_resources_listing_no_resources_found", Res.string.ui_resources_listing_no_resources_found)
  map.put("ui_resources_listing_search_pick_placeholder", Res.string.ui_resources_listing_search_pick_placeholder)
  map.put("ui_resources_listing_search_placeholder", Res.string.ui_resources_listing_search_placeholder)
  map.put("ui_resources_listing_showing", Res.string.ui_resources_listing_showing)
  map.put("ui_resources_splash_desc", Res.string.ui_resources_splash_desc)
  map.put("ui_resources_splash_title", Res.string.ui_resources_splash_title)
  map.put("ui_target_campaign", Res.string.ui_target_campaign)
  map.put("ui_target_campaigns", Res.string.ui_target_campaigns)
  map.put("ui_target_companies", Res.string.ui_target_companies)
  map.put("ui_target_company", Res.string.ui_target_company)
  map.put("ui_target_device", Res.string.ui_target_device)
  map.put("ui_target_devices", Res.string.ui_target_devices)
  map.put("ui_target_location", Res.string.ui_target_location)
  map.put("ui_target_locations", Res.string.ui_target_locations)
  map.put("ui_target_resource", Res.string.ui_target_resource)
  map.put("ui_target_resources", Res.string.ui_target_resources)
  map.put("ui_target_user", Res.string.ui_target_user)
  map.put("ui_target_users", Res.string.ui_target_users)
  map.put("ui_uploader_btn_image", Res.string.ui_uploader_btn_image)
  map.put("ui_uploader_btn_try_again", Res.string.ui_uploader_btn_try_again)
  map.put("ui_uploader_btn_video", Res.string.ui_uploader_btn_video)
  map.put("ui_uploader_desc_image", Res.string.ui_uploader_desc_image)
  map.put("ui_uploader_desc_video", Res.string.ui_uploader_desc_video)
  map.put("ui_uploader_error_prefix", Res.string.ui_uploader_error_prefix)
  map.put("ui_uploader_fail_title", Res.string.ui_uploader_fail_title)
  map.put("ui_uploader_status_back", Res.string.ui_uploader_status_back)
  map.put("ui_uploader_status_init", Res.string.ui_uploader_status_init)
  map.put("ui_uploader_status_processing", Res.string.ui_uploader_status_processing)
  map.put("ui_uploader_status_secure_legend", Res.string.ui_uploader_status_secure_legend)
  map.put("ui_uploader_status_secure_transfer", Res.string.ui_uploader_status_secure_transfer)
  map.put("ui_uploader_status_uploading", Res.string.ui_uploader_status_uploading)
  map.put("ui_uploader_subtitle", Res.string.ui_uploader_subtitle)
  map.put("ui_uploader_title", Res.string.ui_uploader_title)
  map.put("ui_users_activity_btn_next", Res.string.ui_users_activity_btn_next)
  map.put("ui_users_activity_btn_prev", Res.string.ui_users_activity_btn_prev)
  map.put("ui_users_activity_empty", Res.string.ui_users_activity_empty)
  map.put("ui_users_activity_filter_action", Res.string.ui_users_activity_filter_action)
  map.put("ui_users_activity_filter_all", Res.string.ui_users_activity_filter_all)
  map.put("ui_users_activity_filter_target", Res.string.ui_users_activity_filter_target)
  map.put("ui_users_activity_header_action", Res.string.ui_users_activity_header_action)
  map.put("ui_users_activity_header_details", Res.string.ui_users_activity_header_details)
  map.put("ui_users_activity_header_timestamp", Res.string.ui_users_activity_header_timestamp)
  map.put("ui_users_activity_header_user", Res.string.ui_users_activity_header_user)
  map.put("ui_users_activity_hours_ago", Res.string.ui_users_activity_hours_ago)
  map.put("ui_users_activity_mins_ago", Res.string.ui_users_activity_mins_ago)
  map.put("ui_users_activity_now", Res.string.ui_users_activity_now)
  map.put("ui_users_activity_title", Res.string.ui_users_activity_title)
  map.put("ui_users_detail_btn_audit_trail", Res.string.ui_users_detail_btn_audit_trail)
  map.put("ui_users_detail_btn_delete", Res.string.ui_users_detail_btn_delete)
  map.put("ui_users_detail_btn_edit", Res.string.ui_users_detail_btn_edit)
  map.put("ui_users_detail_btn_reset_pass", Res.string.ui_users_detail_btn_reset_pass)
  map.put("ui_users_detail_cat_campaigns", Res.string.ui_users_detail_cat_campaigns)
  map.put("ui_users_detail_cat_company", Res.string.ui_users_detail_cat_company)
  map.put("ui_users_detail_cat_devices", Res.string.ui_users_detail_cat_devices)
  map.put("ui_users_detail_cat_locations", Res.string.ui_users_detail_cat_locations)
  map.put("ui_users_detail_cat_media", Res.string.ui_users_detail_cat_media)
  map.put("ui_users_detail_cat_users", Res.string.ui_users_detail_cat_users)
  map.put("ui_users_detail_delete_btn_confirm", Res.string.ui_users_detail_delete_btn_confirm)
  map.put("ui_users_detail_delete_btn_dismiss", Res.string.ui_users_detail_delete_btn_dismiss)
  map.put("ui_users_detail_delete_confirm_message", Res.string.ui_users_detail_delete_confirm_message)
  map.put("ui_users_detail_delete_confirm_title", Res.string.ui_users_detail_delete_confirm_title)
  map.put("ui_users_detail_header_category", Res.string.ui_users_detail_header_category)
  map.put("ui_users_detail_header_delete", Res.string.ui_users_detail_header_delete)
  map.put("ui_users_detail_header_edit", Res.string.ui_users_detail_header_edit)
  map.put("ui_users_detail_header_view", Res.string.ui_users_detail_header_view)
  map.put("ui_users_detail_info_dialog_title", Res.string.ui_users_detail_info_dialog_title)
  map.put("ui_users_detail_log_api_key", Res.string.ui_users_detail_log_api_key)
  map.put("ui_users_detail_log_api_key_sub", Res.string.ui_users_detail_log_api_key_sub)
  map.put("ui_users_detail_log_media", Res.string.ui_users_detail_log_media)
  map.put("ui_users_detail_log_media_sub", Res.string.ui_users_detail_log_media_sub)
  map.put("ui_users_detail_log_sync", Res.string.ui_users_detail_log_sync)
  map.put("ui_users_detail_log_sync_sub", Res.string.ui_users_detail_log_sync_sub)
  map.put("ui_users_detail_reset_success_msg", Res.string.ui_users_detail_reset_success_msg)
  map.put("ui_users_detail_title_permissions_matrix", Res.string.ui_users_detail_title_permissions_matrix)
  map.put("ui_users_detail_title_recent_logs", Res.string.ui_users_detail_title_recent_logs)
  map.put("ui_users_edit_btn_ok", Res.string.ui_users_edit_btn_ok)
  map.put("ui_users_edit_btn_save", Res.string.ui_users_edit_btn_save)
  map.put("ui_users_edit_error_title", Res.string.ui_users_edit_error_title)
  map.put("ui_users_edit_label_full_name", Res.string.ui_users_edit_label_full_name)
  map.put("ui_users_edit_label_login_id", Res.string.ui_users_edit_label_login_id)
  map.put("ui_users_edit_role_admin", Res.string.ui_users_edit_role_admin)
  map.put("ui_users_edit_role_campaign_publisher", Res.string.ui_users_edit_role_campaign_publisher)
  map.put("ui_users_edit_role_campaign_viewer", Res.string.ui_users_edit_role_campaign_viewer)
  map.put("ui_users_edit_role_technic", Res.string.ui_users_edit_role_technic)
  map.put("ui_users_edit_role_warning_message", Res.string.ui_users_edit_role_warning_message)
  map.put("ui_users_edit_role_warning_title", Res.string.ui_users_edit_role_warning_title)
  map.put("ui_users_edit_section_roles", Res.string.ui_users_edit_section_roles)
  map.put("ui_users_edit_title_user_profile", Res.string.ui_users_edit_title_user_profile)
  map.put("ui_users_listing_btn_add_user", Res.string.ui_users_listing_btn_add_user)
  map.put("ui_users_listing_btn_load_more", Res.string.ui_users_listing_btn_load_more)
  map.put("ui_users_listing_header_activity", Res.string.ui_users_listing_header_activity)
}
